export default class MobileMenu {
    constructor() {
        this.init();
    }
    init() {
        const menuToggle = document.querySelector('#mobile-toggle');
        const menu = document.querySelector('#mobile-menu-container');
        if (menuToggle && menu) {
            menuToggle.addEventListener('click', () => {
                menuToggle.classList.toggle('menu-opened');
                menu.classList.toggle('menu-opened');
            });
        }
    }
}
